// extracted by mini-css-extract-plugin
module.exports = {"tooltip-buttons":"tooltip_tooltip-buttons__Kpjly","show":"tooltip_show__EwO8f","tooltip-inner":"tooltip_tooltip-inner__Bu_Kq","arrow":"tooltip_arrow__JAqGS"};